import { render } from "./BalTooltip.vue?vue&type=template&id=37b035c0"
import script from "./BalTooltip.vue?vue&type=script&lang=ts"
export * from "./BalTooltip.vue?vue&type=script&lang=ts"

import "./BalTooltip.vue?vue&type=style&index=0&id=37b035c0&lang=css"
script.render = render

export default script